import React, { Component } from 'react';
import './overlay.css';


class Overlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false
    }
  }

  render() {
    return(
      <div style={{'display': `${this.props.toggleOverlay ? 'block' : 'none'}`}} className="overlay-container">
        <ul className="">
          <li>
            <a href="/home">/Home</a>
          </li>
          <li>
            <a href="/work">/Work</a>
          </li>
          <li>
            <a href="https://drive.google.com/file/d/1Jq-pif_GjPUlkD8NwuBHH2Yq1DRVFyWz/view?usp=sharing"
               rel="noopener noreferrer"
               target="_blank">
              /Resume
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default Overlay;
